import { useState, useEffect, useCallback } from "react";

export function usePWAInstall() {
  const [canInstall, setCanInstall] = useState(!!window.__wadoDeferredPrompt);
  const [installed, setInstalled] = useState(
    window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true
  );

  useEffect(() => {
    const onCan = () => setCanInstall(true);
    const onInstalled = () => {
      setCanInstall(false);
      setInstalled(true);
    };
    window.addEventListener("wado-can-install", onCan);
    window.addEventListener("wado-installed", onInstalled);
    return () => {
      window.removeEventListener("wado-can-install", onCan);
      window.removeEventListener("wado-installed", onInstalled);
    };
  }, []);

  const promptInstall = useCallback(async () => {
    const dp = window.__wadoDeferredPrompt;
    if (!dp) return false;
    dp.prompt();
    const { outcome } = await dp.userChoice;
    window.__wadoDeferredPrompt = null;
    setCanInstall(false);
    return outcome === "accepted";
  }, []);

  const isIOS = /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;

  return { canInstall, installed, promptInstall, isIOS };
}
